<!-- this component is to determine how weak / strong a password and display a meter -->
<template>

    <div>

        <object v-if="showInlinePreview" :data="pdfUrl" type="application/pdf" style="width:100%;min-height:950px;">
            <div class="col-xs-12">Preview Form: <a :href="pdfUrl" target="_blank">Download</a></div>
        </object>

        <div v-else>
            <p>
                This device does not support an inline preview. Please click the download button to review the submitted document. <a :href="pdfUrl" target="_blank">Download</a>
            </p>
        </div>

    </div>

</template>

<script>

    export default {
        name: 'pdf-preview-component',
        props: {
            'showInlinePreview': { type: Boolean },
            'pdfUrl': { type: String }
        }
    };
</script>
